<template>
 <BRow>
        <BCol v-for="(category, i) in visibleCategories" :key="i"  
               :xl="xl" 
               :lg="lg"
               :md="md">
        <section class="pbk-card">
          <header class="pbk-head">
            <NuxtLink class="pbk-title-link" :to="routePath({name:'cene-na-pijacama-category',params:{category: $srbTolat.srbTolat(category.description)}})">
              <component :is="titleTag" class="pbk-title">{{ category.description }}</component>
            </NuxtLink>
            <NuxtLink class="pbk-all" :to="routePath({name:'cene-na-pijacama-category',params:{category: $srbTolat.srbTolat(category.description)}})">
              pogledaj sve
            </NuxtLink>
          </header>

          <ul class="pbk-list">
            <li v-for="(subcategory, i) in visibleSubs(category)" :key="i">
              <NuxtLink class="pbk-link"
                        :to="routePath({name:'cene-na-pijacama-category-subcategory-year', params:{category: $srbTolat.srbTolat(category.description),
                                                                                                    subcategory: $srbTolat.srbTolat(subcategory.description) ,
                                                                                                    year: getFullYear()
                                                                                               }})">
                <client-only>
                  <i :class="`esei ${subcategory.svg} esei-default avatar-block text-white bg-${subcategory.color} p-1 pbk-icon`"></i>
                </client-only>
                <span class="pbk-link-text">{{ subcategory.description }}</span>
                <span class="pbk-link-cta">
                  Pogledaj cene
                  <span class="pbk-link-arrow" aria-hidden="true">›</span>
                </span>
              </NuxtLink>
            </li>
          </ul>
        </section>
    </BCol>
</BRow>
</template>

<script setup>

import { BRow, BCol } from 'bootstrap-vue-next';

const routePath = useRoutePath()

 
const { $srbTolat } = useNuxtApp()
 

const nuxtApp = useNuxtApp()


const locale = ref('sr')

const props = defineProps({
  // oznaka naslova kartice: "div" (obican tekst, bocne kolone) ili "h2"/"h3" kad je kartica glavni sadrzaj stranice
  titleTag: { type: String, default: "div" },
  searchable: { type: Boolean, default: false },
     categories:{
   type: Array 
   
 },
    cols:{
   type: Number,
   require: true
 },
  xl:{
   type: Number,
   require: true,
   default: 4
 },
  lg:{
   type: Number,
   require: true,
   default: 4
 },
  md:{
   type: Number,
   require: true,
   default: 6
 },
  counter:{
   type: Number,
   require: true,
   default: 6
 },
 from:{
    type: Number,
    require: true,
    default: 0
 },
 display:{
   type:Boolean,
   default:true
 },
 display_avatar:{
      type:Boolean,
      default:true
  },
  display_avatar_food:{
      type:Boolean,
      default:true
  },
  others_page:{
    type:Boolean,
      default:false
  },
  fix_height:{
    type:Boolean,
    default: true
  },
  category_name_ads:String
  })

  
const countBlock = (items, from, count) => {

return items != undefined ? items.slice(from, count) : []

}
const sliceSuncategories = (items) => {

return items.slice(0, 6);

}

const getFullYear = () => {
  return new Date().getFullYear()
}

// lokalni filter stranice (<ListFilter />): kartica ostaje ako naslov ili neka stavka odgovara
// filtriranje samo kad stranica to trazi (:searchable="true"), da bočne liste ne reaguju na polje u glavnoj koloni
const listFilter = useListFilter()
const active = computed(() => props.searchable && listFilter.active.value)
const match = listFilter.match

const visibleCategories = computed(() => {
  const slice = countBlock(props.categories, props.from, props.counter)

  if (!active.value) return slice

  return slice
    .map((category) => (match(category.description)
      ? category
      : { ...category, subcategories: (category.subcategories ?? []).filter((sub) => match(sub.description)) }))
    .filter((category) => (category.subcategories ?? []).length > 0)
})

// sa aktivnim filterom nema ogranicenja broja stavki u kartici
const visibleSubs = (category) => (active.value ? (category.subcategories ?? []) : sliceSuncategories(category.subcategories))

useListFilterHits(computed(() => (active.value ? visibleCategories.value.reduce((n, c) => n + (c.subcategories ?? []).length, 0) : 1)), props.searchable)
 
</script>

